export function downloadFile(fileName: string, fileContent: string) {
  const blob = new Blob([fileContent], { type: 'text/json' });
  const link = document.createElement('a');
  link.download = fileName;
  link.href = URL.createObjectURL(blob);
  document.body.append(link);
  link.click();
}
